
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import StripeSubscriptionService from '@/Services/Subscription/StripeSubscriptionService';
import Authenticator from '@/Services/Auth/Authenticator';
import { User } from '@/classes/auth';
import Alert from '@/components/Alert.vue';
import Dismiss from '@/components/Dismiss.vue';
import { SupportModalMixin } from '@/mixins/SupportModalMixin';
import store from '@/store';

@Component({
  components: {
    Alert,
    Dismiss,
  },
  computed: {
    ...mapGetters('subscription', {
      isEnterprise: 'isEnterprise', // <- for runtime
    }),
  },
})
export default class CancelPauseSubscription extends SupportModalMixin {
  // region PROPS
  @Prop(Boolean)
  open!: boolean;
  // endregion PROPS END

  subscription = store.state.subscription.activeSubscription;

  // region PROPERTIES
  stripeSubscriptionService: StripeSubscriptionService = new StripeSubscriptionService();
  user: User = Authenticator.getUser();
  // endregion PROPERTIES END

  // getter from vuex
  isEnterprise!: boolean;

  get planName() {
    return this.stripeSubscriptionService.findPlan(this.subscription.plan_id)?.title;
  }

  // endregion COMPUTED

  cancel() {
    this.$emit('cancel');
  }

  @Watch('open')
  onOpenChange(open: boolean) {
    if (!open) {
      return;
    }
  }
}
